import {createSlice} from "@reduxjs/toolkit";


const initialReportState = {
    listLoading: false,
    actionsLoading: false,
    fetchingReportStr: false,
    totalCount: 0,
    entities: [],
    reportTypes: [],
    reportName: "",
    reportFormat: "",
    reportDataString: "",
    reportForEdit: undefined,
    error: null
  };

  export const callTypes = {
    list: "list",
    action: "action",
    fetch: "fetch"
  };

const reportsSlice = createSlice({
    name: 'reports',
    initialState:initialReportState,
    reducers: {
        catchError: (state, action) => {
          state.error = `${action.type}: ${action.payload.error}`;
          if (action.payload.callType === callTypes.list) {
            state.listLoading = false;
          } else if(action.payload.callType === callTypes.fetch) {
            state.fetchingReportStr = false;
          } else {
            state.actionsLoading = false;
          }
        },
        startCall: (state, action) => {
          state.error = null;
          if (action.payload.callType === callTypes.list) {
            state.listLoading = true;
          } else if(action.payload.callType === callTypes.fetch) {
            state.fetchingReportStr = true;
          } else {
            state.actionsLoading = true;
          }
        },
        // getReportsById
        reportFetched: (state, action) => {
          state.actionsLoading = false;
          state.reportForEdit = action.payload.reportForEdit;
          state.error = null;
        },
        //get the different report types
        reportTypesFetched: (state, action) => {
          const { reportTypes } = action.payload;
          state.error = null;
          state.listLoading = false;
          state.reportTypes = reportTypes;
        },
        // findReports
        reportsFetched: (state, action) => {
          const { reportStr } = action.payload;
          state.fetchingReportStr = false;
          state.error = null;
          state.reportDataString = reportStr;
        },
        // reportCreated
        reportCreated: (state, action) => {
          state.actionsLoading = false;
          state.error = null;
          state.entities.push(action.payload.report);
        },
        // updateReport
        reportUpdated: (state, action) => {
          state.error = null;
          state.actionsLoading = false;
          state.entities = state.entities.map(entity => {
            if (entity.id === action.payload.report.id) {
              return action.payload.report;
            }
            return entity;
          });
        },
        // deletereport
        reportDeleted: (state, action) => {
          state.error = null;
          state.actionsLoading = false;
          state.entities = state.entities.filter(el => el.id !== action.payload.id);
        },
        // deletereports
        reportsDeleted: (state, action) => {
          state.error = null;
          state.actionsLoading = false;
          state.entities = state.entities.filter(
            el => !action.payload.ids.includes(el.id)
          );
        },
        // reportsUpdateState
        reportStatusUpdated: (state, action) => {
          state.actionsLoading = false;
          state.error = null;
          const { ids, status } = action.payload;
          state.entities = state.entities.map(entity => {
            if (ids.findIndex(id => id === entity.id) > -1) {
              entity.status = status;
            }
            //changes each entity in the array
            return entity;
          });
        },
        reportStateClear: (state) => {
          state.actionsLoading = false;
          state.listLoading = false;
          state.error = null;
          state.entities = [];
          state.reportName = "";
        }
      }
});

export const {actions} = reportsSlice;
export const {reducer} = reportsSlice;